import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Outlet } from 'react-router-dom';
import NavigationSidebar from '../Navigation/NavigationSidebar';
import MobileDrawerToggle from '../Navigation/MobileDrawer';
import { useNavigation } from '../Navigation/NavigationContext';

const DashboardLayout: React.FC = () => {
  const theme = useTheme();
  const { sidebarOpen, toggleSidebar } = useNavigation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const sidebarWidth = sidebarOpen ? 280 : 72;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* サイドバー */}
      <NavigationSidebar open={sidebarOpen} onToggle={toggleSidebar} />

      {/* モバイル用メニューボタン */}
      <MobileDrawerToggle />

      {/* メインコンテンツ */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: '100%',
          paddingLeft: isMobile ? 3 : 3,
          transition: theme.transitions.create(['padding'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          backgroundColor: theme.palette.background.default,
          minHeight: '100vh',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardLayout;